import { ITranslationService } from "../../service/locale/TranslationService";
import { INotificationService } from "../../service/notification/NotificationService";

export default class ShowUnauthorizedMsgInteractor {
  private translationService: ITranslationService;
  private notificationService: INotificationService;

  constructor(translationService, notificationService) {
    this.translationService = translationService;
    this.notificationService = notificationService;
  }

  execute() {
    this.notificationService.showError(
      this.translationService.get("error.unauthorized_msg")
    );
  }
}
